<template>
    <div class="chat" :style="
                    '--background-color:'+client_settings.background
                    +';--buttons-color:'+client_settings.buttons_color
                    +';--buttons-inactive-color:'+client_settings.buttons_inactive_color
                    +';--buttons-text-color:'+client_settings.buttons_text_color
                    +';--buttons-inactive-text-color:'+client_settings.buttons_inactive_text_color
                    +';--to-speaker-color:'+client_settings.to_speaker_color
                    +';--pinned-color:'+client_settings.pinned_color
                    +';--input-buttons-color:'+client_settings.input_buttons_color
                    +';--role-admin-color:'+client_settings.role_admin_color
                    +';--role-moderator-color:'+client_settings.role_moderator_color
                    +';--role-speaker-color:'+client_settings.role_speaker_color
                    +';--role-audience-color:'+client_settings.role_audience_color
                    +';--messages-text-color:'+client_settings.messages_text_color
                    +';--messages-border-color:'+client_settings.messages_border_color
                    +';--chat-height:'+settings.chat_height
                    +';--emoji-height:'+settings.emoji_height

                ">
        <div v-if="ext_id" class="card card-default border-main" :style="'background:'+client_settings.background">
            <div class="card-header card-header-chat">
                <h4 class="float-left mb-0">{{ room.name }} &mdash; {{ text_lang[this.room.language]["text_messages"]}}</h4>
                <div class="to-speaker-box float-right ml-2">

                </div>
                <div class="rooms float-right" v-if="!prop_room_id">
                    <div>
                        <b-dropdown id="dropdown-1" :text="this.room.name" :right=true>
                            <b-dropdown-item v-for="(room_item, index) in this.rooms" :key="index" @click="setRoom(room_item.id)">{{room_item.name}} ({{room_item.language}})</b-dropdown-item>
                        </b-dropdown>
                    </div>
                </div>

                <private-messages v-if="PMReady" :private_messages="private_messages" ref="pm"></private-messages>

                <div class="disablePinned-btn-box float-right mr-2" v-if="this.room.pinned_messages.length>0">
                    <button class="btn-sm" :class="{'active': disablePinned}" @click="disablePinned = !disablePinned">
                        <b-icon-bookmark></b-icon-bookmark>
                    </button>
                </div>

                <div class="pinned-box" :class="{ disabled: disablePinned }" :style="'background:'+client_settings.background" v-if="this.room.pinned_messages.length>0">
                    <ul class="list-unstyled p-0 m-0" v-if="room.pinned_messages">
                        <li :class="'p-1 my-2 mr-1 border rounded'" v-for="(pinned_message) in room.pinned_messages" :key="pinned_message.id" style="overflow:hidden;">
                            <div class="pinned-badge"><b-icon-chat-square-quote class="question-icon"></b-icon-chat-square-quote></div>
                            <strong :class="'username ' + 'role-' + pinned_message.user.roles[0].name">
                                {{ pinned_message.user.name }}
                            </strong>
                            <div class="message-text">{{pinned_message.message}}</div>
                        </li>
                    </ul>
                </div>

            </div>
            <div class="card-body">

                <messages-list
                        :room="room"
                        :client_settings="client_settings"
                        :user="user"
                        :text_lang="text_lang"
                        :reply_message="reply_message"
                        :PMReady="PMReady"
                        v-on:setReply="setReply($event)"
                        v-on:rightMenuOpen="rightMenuOpen($event)"
                        v-on:setPrivateMessageTo="setPrivateMessageTo($event)"
                ></messages-list>

                <div :class="(to_speaker?'message-input-box-to-speaker':'') + ' message-input-box'" v-if="anon_ext_id || (settings.type === 'login' || settings.type === 'login_csv')">
                    <div v-if="reply_message">
                        <div class="reply-to">
                            {{reply_message.user.name}}<br>
                            {{truncate(reply_message.message, 70)}}
                        </div>

                    </div>

                    <label for="message" v-if="this.to_speaker">{{ text_lang[room.language]["text_question"]}}</label>
                    <label for="message" v-else-if="this.reply_message">{{ text_lang[room.language]["text_input_reply"]}} {{reply_message.user.name}} <b-button @click="clearReply()" variant="link" size="sm" class="m-0 p-0 ml-2 float-right" title="Отменить ответ"><b-icon-x></b-icon-x></b-button></label>
                    <label for="message" v-else>{{ text_lang[room.language]["text_input_message"]}} ({{this.user.name==='Аноним'?text_lang[room.language]['text_anon']:this.user.name}})</label>
                    <button class="btn-question-button float-right mb-1" :title="text_lang[room.language]['text_input_question']" @click="toggleToSpeaker()">
                        <span v-if="!to_speaker" class="btn-question-text">{{ text_lang[room.language]["text_input_question"]}}</span>
                        <span v-else class="btn-question-text"><br>{{ text_lang[room.language]["text_cancel"]}}<br></span>
                        <b-icon-question v-if="!to_speaker"></b-icon-question>
                        <b-icon-x v-else></b-icon-x>
                    </button>
                    <input
                            @keyup.enter="sendMessage"
                            v-model="newMessage"
                            type="text"
                            name="message"
                            id="message"
                            :placeholder="client_settings.message_placeholder"
                            class="form-control input-box"
                            maxlength="180">

                    <button class="btn-send" @click="sendMessage"><b-icon-play></b-icon-play></button>

                    <emoji-picker @emoji="append" :search="search" :emojiTable="emojis">
                        <div
                                class="emoji-invoker float-right"
                                slot="emoji-invoker"
                                slot-scope="{ events: { click: clickEvent } }"
                                @click.stop="clickEvent"
                        >
                            <svg height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
                                <path d="M0 0h24v24H0z" fill="none"/>
                                <path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm3.5-9c.83 0 1.5-.67 1.5-1.5S16.33 8 15.5 8 14 8.67 14 9.5s.67 1.5 1.5 1.5zm-7 0c.83 0 1.5-.67 1.5-1.5S9.33 8 8.5 8 7 8.67 7 9.5 7.67 11 8.5 11zm3.5 6.5c2.33 0 4.31-1.46 5.11-3.5H6.89c.8 2.04 2.78 3.5 5.11 3.5z"/>
                            </svg>
                        </div>
                        <div slot="emoji-picker" slot-scope="{ emojis, insert }">
                            <div class="emoji-picker" >
                                <div class="emoji-picker__search" v-bind:class="{ hide: !settings.emoji_search }">
                                    <input type="text" v-model="search" v-focus>
                                </div>
                                <div>
                                    <div v-for="(emojiGroup, category) in emojis" :key="category">
                                        <h5>{{ category }}</h5>
                                        <div class="emojis">
                                        <span
                                                v-for="(emoji, emojiName) in emojiGroup"
                                                :key="emojiName"
                                                @click="insert(emoji)"
                                                :title="emojiName"
                                        >{{ emoji }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </emoji-picker>
                </div>
                <div class="enter-name-box" v-else>
                    <b-form-input
                            id="input-1"
                            v-model="field_name"
                            type="text"
                            required
                            :placeholder='text_lang[room.language]["text_enter_placeholder"]'
                            size="sm"
                            class="mt-1"
                            maxlength="48"
                            v-show="this.settings.name_btn"
                    ></b-form-input>
                    <b-button v-show="this.settings.name_btn" size="sm" @click="anon_ext_id = field_name&&changeName()" class="mt-1 mr-1" :style="'background:'+client_settings.buttons_color+';color:'+client_settings.buttons_text_color">{{ text_lang[room.language]["text_enter"]}}</b-button>
                    <b-button v-show="this.settings.anonymous_btn" size="sm" @click="anon_ext_id = text_lang[room.language]['text_anon']" class="mt-1" :class="settings.anonymous_btn&&!settings.name_btn?'my-3':''" :style="'background:'+client_settings.buttons_color+';color:'+client_settings.buttons_text_color+';'+(settings.anonymous_btn&&!settings.name_btn?'display:block;margin:0 auto;':'')">{{ text_lang[room.language]["text_enter_anon"]}}</b-button>
                </div>
            </div>
        </div>
        <div style="background: #FFF;padding: 20px;text-align: center;" v-else>
            <div v-if="banned">К сожалению, вы были забанены в чате.</div>
            <div v-else>
                <div v-if="settings.type === 'login' || settings.type === 'login_csv'">
                    Чат недоступен для гостей.
                </div>
                <div v-else-if="settings.type === 'anonymous'">
                    <b-form-input
                            id="input-1"
                            v-model="field_name"
                            type="text"
                            required
                            placeholder="Введите ваше имя"
                            size="sm"
                            class="mt-1"
                            maxlength="48"
                    ></b-form-input>
                    <b-button size="sm" @click="anon_ext_id = field_name&&changeName()" class="mt-1 mr-1" :style="'background:'+client_settings.buttons_color+';color:'+client_settings.buttons_text_color">{{ text_lang[room.language]["text_enter"]}}</b-button>
                    <b-button v-show="this.settings.anonymous_btn" size="sm" @click="anon_ext_id = text_lang[room.language]['text_anon']" class="mt-1" :class="settings.anonymous_btn&&!settings.name_btn?'my-3':''" :style="'background:'+client_settings.buttons_color+';color:'+client_settings.buttons_text_color+';'+(settings.anonymous_btn&&!settings.name_btn?'display:block;margin:0 auto;':'')">{{ text_lang[room.language]["text_enter_anon"]}}</b-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from "vue";
    import Echo from "laravel-echo";
    import EmojiPicker from 'vue-emoji-picker'
    //import ContextMenu from "./ContextMenu/ContextMenu";
    //import ContextMenuItem from "./ContextMenu/ContextMenuItem";
    import PrivateMessages from "./PrivateMessages";
    import MessagesList from "./MessagesList";

    Vue.use(EmojiPicker)

    export default {
        props: [],
        components: {
            EmojiPicker,
            //ContextMenu,
            //ContextMenuItem,
            PrivateMessages,
            MessagesList
        },
        directives: {
            focus: {
                inserted(el) {
                    el.focus()
                },
            },
        },
        data() {
            return {
                prop_room_id: null,
                loading: false,
                ext_id: '',
                anon_ext_id: '',
                field_name: '',
                user: {},
                messages: [],
                rooms: [],
                room: {'name':'', 'language':'ru', pinned_messages: []},
                room_id: '',
                newMessage: '',
                reply_message: null,
                token: '',
                settings: {},
                to_speaker: false,
                search: '',
                disablePinned: false,
                disablePrivateMessages: true,
                private_messages: {},
                private_message_to: null,
                PMReady: false,
                banned: false,
                client_settings: {
                    "background": "#FFF",
                    "messages_approving":"false",
                    "messages_background":"#FFF",
                    "messages_text_color":"#000",
                    "messages_border_width":"1px",
                    "messages_border_color":"#17a2b8",
                    "to_speaker_color":"#17a2b8",
                    "pinned_color":"#008b8b",
                    "buttons_color":"#52B788",
                    "buttons_inactive_color":"#42A778",
                    "buttons_text_color":"#FFF",
                    "buttons_inactive_text_color":"#000",
                    "message_placeholder":"Введите сообщение...",
                    "input_buttons_color":"#CCC",
                    "role_admin_color":"#2FA360",
                    "role_moderator_color":"#F8FF88",
                    "role_speaker_color":"#FF7BA5",
                    "role_audience_color":"#3F9AE5",
                },
                text_lang: {
                    "ru": {
                        "text_messages": 'Сообщения',
                        "text_input_message": 'Ваше сообщение',
                        "text_input_question": 'Задать вопрос спикеру',
                        "text_question": 'Вопрос спикеру',
                        "text_input_reply": 'Ответ на сообщение',
                        "text_reply": 'Ответить',
                        "text_message_to": 'для',
                        "text_pm": 'Личное сообщение',
                        "text_pm_title": 'Личные сообщения',
                        "text_pm_description": 'Чтобы создать диалог нажмите левой кнопкой мыши на имя пользователя в чате. Внимание: диалоги могут быть просмотрены/удалены модератором, так же как и сообщения в общем чате.',
                        "text_pm_conversation": 'Диалог',
                        "text_pm_with": 'с',
                        "text_cancel": "Отмена",
                        "text_enter": "Войти",
                        "text_enter_anon": "Войти анонимно",
                        "text_enter_placeholder": "Введите ваше имя",
                        "text_anon": "Аноним"
                    },
                    "en": {
                        "text_messages": 'Messages',
                        "text_input_message": 'Your message',
                        "text_input_question": 'Ask speaker question',
                        "text_question": 'Question to speaker',
                        "text_input_reply": 'Reply to',
                        "text_reply": 'Reply',
                        "text_message_to": 'to',
                        "text_pm": 'Private message',
                        "text_pm_title": 'Private messages',
                        "text_pm_description": 'To create a conversation, left-click on the user name in the chat.',
                        "text_pm_conversation": 'Conversation',
                        "text_pm_with": 'with',
                        "text_cancel": "Cancel",
                        "text_enter": "Enter",
                        "text_enter_anon": "Enter anonymously",
                        "text_enter_placeholder": "Enter your name",
                        "text_anon": "Anonymous"
                    }
                },
                join_echo: false,
                emojis: {
                    '': {
                        'thumbs_up': '👍',
                        'blush': '😊',
                        'heart_eyes': '😍',
                    }
                },
            }
        },
        created() {
            this.$http.get('./settings.json')
            .then((response) => {
                this.settings = response.data;
                if(this.settings.room_id) {
                    this.prop_room_id = this.settings.room_id;
                }
                //this.ext_id = new URL(location.href).searchParams.get('ext_id');

                if(this.settings.type === 'login' || this.settings.type === 'login_csv') {
                    try {
                        if(new URL(location.href).searchParams.get('ext_id')) {
                            this.ext_id = atob(new URL(location.href).searchParams.get('ext_id'));
                        }
                    } catch(e) {
                        console.log(e);
                    }
                    if(this.ext_id) {
                        this.auth();
                        if(this.prop_room_id) {
                            this.room_id = this.prop_room_id;
                        } else {
                            this.room_id = 1;
                        }
                    }
                }
                else if(this.settings.type==='anonymous') {
                    this.auth_anon();

                    if(this.prop_room_id) {
                        this.room_id = this.prop_room_id;
                    } else {
                        this.room_id = 1;
                    }
                }
            });

            this.$http.get('./emojis.json')
                .then((response) => {
                    this.emojis = response.data;
                });
        },
        methods: {
            rightMenuOpen(index, event) {
                this.$refs.menu.forEach((el,i) => {
                    this.$refs.menu[i].close();
                });
                this.$refs.menu[index].open(event, '');
            },
            setPrivateMessageTo(user_to) {
                // this.$refs.menu.forEach((el,i) => {
                //     this.$refs.menu[i].close();
                // });
                this.$refs.pm.setConversationFromParent(user_to);
            },
            append(emoji) {
                this.newMessage += emoji
            },
            toggleToSpeaker() {
                this.reply_message = null;
                this.to_speaker = !this.to_speaker;
            },
            setReply(reply) {
                this.reply_message = reply;
                let inputbox = this.$el.querySelector(".input-box");
                inputbox.focus();
            },
            clearReply() {
                this.reply_message = null;
            },
            setRoom(newRoomId) {
                this.stopListening();
                this.room_id = newRoomId;
                this.clearReply();
                this.getMessages();
                this.joinEcho();
            },
            stopListening() {
                this.join_echo = false;
                this.$echo.leave('chat_event'+this.settings.event_id+'_room'+this.room_id);
            },
            joinEcho() {
                if(!this.join_echo) {
                    console.log('join echo');

                    this.$echo.join('chat_event'+this.settings.event_id+'_room'+this.room_id)
                        .listen('RoomMessageSent', (e) => {
                            console.log('RoomMessageSent event');
                            if(!this.room.messages.filter(m => m.id === e.message.id).length) {
                                this.room.messages.push(e.message);
                            }
                        })
                        .listen('RoomMessagePin', (e) => {
                            console.log('RoomMessagePin event');
                            this.room.messages = this.room.messages.filter(m => m.id !== e.message.id);
                            if(!this.room.pinned_messages.filter(m => m.id === e.message.id).length) {
                                this.room.pinned_messages.push(e.message);
                            }
                        })
                        .listen('RoomMessageUnPin', (e) => {
                            console.log('RoomMessageUnPin event');
                            this.room.pinned_messages = this.room.pinned_messages.filter(m => m.id !== e.message.id);
                            if(!this.room.messages.filter(m => m.id === e.message.id).length) {
                                this.room.messages.push(e.message);
                            }
                        })
                        .listen('RoomMessageDelete', (e) => {
                            console.log('RoomMessageDelete event');
                            this.room.messages = this.room.messages.filter(m => m.id !== e.message.id);
                        })
                        .listen('RoomMessageUnDelete', () => {
                            console.log('RoomMessageUnDelete event');
                            this.getMessages();
                        });

                    this.join_echo = true;
                }
            },
            getClientSettings() {
                this.$http.get(this.settings.protocol + this.settings.server + '/api/settings/'+this.settings.event_id, {
                    headers: { Authorization: 'Bearer '+this.token }
                }).then(response => {
                    this.client_settings = response.data;
                    let roombtn = this.$el.querySelector(".rooms button");
                    if(roombtn) {
                        roombtn.style.background= this.client_settings.buttons_color;
                    }
                })
            },
            getRooms() {
                this.$http.get(this.settings.protocol + this.settings.server + '/api/rooms/' + this.settings.event_id, {
                    headers: { Authorization: 'Bearer '+this.token }
                }).then(response => {
                    this.rooms = response.data;
                    if(!this.prop_room_id) {
                        this.room_id = this.rooms[0].id;
                    }
                    this.getMessages();
                })
            },
            getMessages() {
                this.$http.get(this.settings.protocol + this.settings.server + '/api/messages/' + this.room_id, {
                    headers: { Authorization: 'Bearer '+this.token }
                }).then(response => {
                    this.room = response.data;

                    //this.messages = response.data.messages;
                    //this.room_id = response.data.id;
                    this.joinEcho();
                })
            },
            getPrivateMessages() {
                this.$http.get(this.settings.protocol + this.settings.server + '/api/pm/', {
                    headers: { Authorization: 'Bearer '+this.token }
                }).then(response => {
                    this.private_messages = response.data;

                    //this.messages = response.data.messages;
                    //this.room_id = response.data.id;
                    //this.joinEcho();
                })
            },
            changeName() {
                this.$http.post(this.settings.protocol + this.settings.server + '/api/changeName', {'ext_id': (this.field_name), 'password': 'secret'}, {
                    headers: { Authorization: 'Bearer '+this.token }
                }).then(response => {
                    this.user = response.data.success;
                    this.anon_ext_id = this.user.name;
                });
            },
            auth_anon() {
                this.ext_id = 'Аноним';
                this.auth();
                if(this.prop_room_id) {
                    this.room_id = this.prop_room_id;
                } else {
                    this.room_id = 1;
                }
            },
            auth() {
                //console.log({'email': (this.u?this.u:'testid3'), 'password': 'secret'});
                let login_endpoint = this.settings.protocol + this.settings.server + '/api/' + this.settings.type;
                if(this.settings.type === 'login_csv') {
                    login_endpoint += '/'+this.settings.event_id;
                }
                this.$http.post(login_endpoint, {'ext_id': (this.ext_id), 'password': 'secret', 'event_id': this.settings.event_id}).then(response => {
                    //console.log(response.data);
                    if(response.data.success === 'error') {
                        this.ext_id = null;
                    } else {
                        this.token = response.data.success.token;
                    }

                    this.$http.post(this.settings.protocol + this.settings.server + '/api/details', {}, {
                        headers: { Authorization: 'Bearer '+this.token }
                    }).then(response => {
                        //console.log(response.data);
                        if(response.data.success.banned === 1) {
                            this.ext_id = null;
                            this.banned = true;
                        } else {
                            this.user = response.data.success;

                            Vue.prototype.$echo = new Echo({
                                authEndpoint : this.settings.protocol + this.settings.server + '/api/broadcasting/auth',
                                broadcaster: 'pusher',
                                key: 'myKey',
                                wsHost: this.settings.server,
                                wsPort: 6001,
                                disableStats: true,
                                encrypted: false,
                                enabledTransports: ['ws','wss'],
                                auth: {
                                    headers: {
                                        Authorization: "Bearer " + this.token
                                    }
                                },
                            });

                            if(this.settings.type !== 'anonymous') {
                                this.PMReady = true;
                            }

                            this.getClientSettings();
                            this.getRooms();
                            // this.getMessages();
                            this.getPrivateMessages();
                        }
                    })
                })

            },
            sendMessage() {
                if(this.newMessage) {
                    this.$http.post(this.settings.protocol + this.settings.server + '/api/messages/'+this.room_id,{message: this.newMessage, reply_to: this.reply_message, to_speaker: this.to_speaker}, {
                        headers: { Authorization: 'Bearer '+this.token }
                    });

                    this.newMessage = '';
                    this.to_speaker = false;
                    this.clearReply();
                }
            },
            deleteMessage(message, message_index) {
                //this.messages = this.messages.filter(m => m !== message);
                this.room.messages[message_index].status='deleted';
                //console.log(message.id)

                this.$http.post(this.settings.server + this.settings.server + '/messageDelete',{message_id: message.id});
            },
            truncate(str, n){
                if (str.length <= n) { return str; }
                const subString = str.substr(0, n-1); // the original check
                return subString.substr(0, subString.lastIndexOf(" ")) + "...";
            },
        },
    }
</script>
<style>
    @import '~vue-context/dist/css/vue-context.css';

    html,body {
        height:100%;
    }
    .role-admin {
        color: var(--role-admin-color);
    }
    .role-moderator {
        color: var(--role-moderator-color);
    }
    .role-speaker {
        color: var(--role-speaker-color);
    }
    .role-audience {
        color: var(--role-audience-color);
    }
    .rooms button {
        background: #52B788;
        color: var(--buttons-text-color);
    }
    .reply-to {
        font-family: 'Roboto Mono',serif;
        margin-left: 2px;
        border-left: 3px solid var(--buttons-color);
        padding-left: 5px;
    }

    .card {
        /*height: 90vh;*/
        height: var(--chat-height);
    }

    .chat-box::-webkit-scrollbar-track
    {
        -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.1);
        background-color: var(--background-color);
        border-radius: 10px;
    }

    .chat-box::-webkit-scrollbar
    {
        width: 10px;
        background-color: var(--background-color);
    }

    .chat-box::-webkit-scrollbar-thumb
    {
        border-radius: 10px;
        background-color: var(--buttons-color);
        /*background-image: -webkit-gradient(linear,*/
        /*40% 0%,*/
        /*75% 84%,*/
        /*from(#4D9C41),*/
        /*to(#19911D),*/
        /*color-stop(.6,#54DE5D))*/
    }

    .chat-box {
        float: left;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        overflow-y: scroll;
        height: calc(100% - 84px);
    }
    .chat-box-with-reply {
        height: calc(100% - 152px);
    }

    .chat-box li {
        margin: 5px 20px;
    }

    .card-body {
        position: relative;
    }

    .message-box {
        padding: 5px;
        border-radius: 6px;
        overflow: hidden;
    }

    .message-input-box-to-speaker {
        /*background-image: -webkit-gradient(linear,*/
        /*40% 0%,*/
        /*75% 84%,*/
        /*from(#4D9C41),*/
        /*to(#19911D),*/
        /*color-stop(.6,#54DE5D)) !important;*/
        background: var(--to-speaker-color) !important;
    }
    .message-input-box-to-speaker label {
        color: #FFF;
    }

    .message-input-box {
        /*float: left;*/
        /*width: calc(100% - 30px);*/
        position: absolute;
        z-index: 2;
        /*height: 84px;*/
        bottom: 0;
        left: 0;
        width: 100%;
        background: var(--background-color);
        border-top: 2px solid var(--buttons-color);
        padding: 5px 20px;
    }

    .input-box {
        padding-right: 70px;
    }

    .enter-name-box {
        position: absolute;
        height: 84px;
        z-index: 2;
        bottom: 0;
        left: 0;
        width: 100%;
        background: var(--background-color);
        border-top: 2px solid var(--buttons-color);
        padding: 5px 20px;
    }

    .message-input-box .message-input {
        padding-right: 64px;
    }

    label[for="message"] {
        font-size: 0.8rem;
        margin: 0;
    }

    .btn-send {
        position: absolute;
        bottom: 6px;
        right: 1.3rem;
        width: 32px;
        height: 36px;
        padding: 0;
        background: none;
        border: 0;
        transition: all 0.2s;
    }

    .btn-send svg {
        color: var(--input-buttons-color);
        font-size: 32px;
    }

    .emoji-invoker {
        position: absolute;
        bottom: 14px;
        right: 3.5rem;
        width: 1.5rem;
        height: 1.5rem;
        border-radius: 50%;
        cursor: pointer;
        transition: all 0.2s;
    }
    .emoji-invoker:hover {
        transform: scale(1.1);
    }
    .emoji-invoker > svg {
        /*fill: #b1c6d0;*/
        fill: var(--input-buttons-color);
    }

    .emoji-picker {
        position: absolute;
        z-index: 1;
        font-family: Montserrat;
        border: 1px solid #ccc;
        width: 15rem;
        height: var(--emoji-height);
        bottom: 52px;
        right: 52px;
        overflow-x: hidden;
        overflow-y: scroll;
        padding: 1rem;
        box-sizing: border-box;
        border-radius: 0.5rem;
        background: #fff;
        box-shadow: 1px 1px 8px #c7dbe6;
    }
    .emoji-picker__search {
        display: flex;
    }
    .emoji-picker__search > input {
        flex: 1;
        border-radius: 10rem;
        border: 1px solid #ccc;
        padding: 0.1rem 0.5rem;
        outline: none;
        width: 100%;
        margin-bottom: 10px;
    }
    .emoji-picker h5 {
        margin-bottom: 0;
        color: #b1b1b1;
        text-transform: uppercase;
        font-size: 0.8rem;
        cursor: default;
    }
    .emoji-picker .emojis {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
    }
    .emoji-picker .emojis:after {
        content: "";
        flex: auto;
    }
    .emoji-picker .emojis span {
        padding: 0.2rem;
        cursor: pointer;
        border-radius: 5px;
    }
    .emoji-picker .emojis span:hover {
        background: #ececec;
        cursor: pointer;
    }

    .message-to-speaker {
        padding-left: 20px;
    }
    .message-to-speaker .question-badge {
        position: absolute;
        left: 0;
        top: 0;
        background: var(--to-speaker-color);
        height: 57px;
        display: flex;
        align-items: center;
        color: #fff;
        font-size: 20px;
        margin-left: -5px;
        margin-top: -5px;
        border-radius: .25rem 0 0 0;
    }
    .message-to-speaker .message-datetime, .message-to-speaker .message-text {
        margin-left: 6px;
    }

    .pinned-box.disabled { display: none; }
    .pinned-box {
        position: absolute;
        display: block;
        top: 50px;
        left: 0px;
        width: 100%;
        padding: 5px 20px;
        margin: 0;
        background: #fff;
        border-bottom: 2px solid var(--buttons-color);
        z-index: 2;
    }
    .pinned-box li {
        padding-left: 28px !important;
        position: relative;
    }
    .pinned-box li .pinned-badge {
        position: absolute;
        left: 0;
        top: 0;
        background: var(--pinned-color);
        height: 57px;
        padding: 0 2px;
        display: flex;
        align-items: center;
        color: #fff;
        font-size: 20px;
    }

    .disablePinned-btn-box button {
        background: var(--buttons-inactive-color);
        height: 38px;
        border: 1px solid #6c757d;
        color: var(--buttons-text-color);
    }
    .disablePinned-btn-box button.active {
        background: var(--buttons-color);
        color: var(--buttons-text-color);
    }
    .disablePinned-btn-box button:focus {
        outline: 0;
    }



    .btn-question-button {
        margin: 0;
        border: 0;
        outline: 0;
        background-color: var(--to-speaker-color);
        color: #FFF;
        padding: 2px;
        border-radius: 10%;
        width: auto;
        height: 27px;
        padding: 0;
        overflow: hidden;
        min-width: 70px;
    }
    .btn-question-button:focus {
        outline: 0;
    }

    .btn-question-button svg {
        border: none;
        width: 27px;
        height: 27px;
        text-align: center;
        text-decoration: none;
        display: inline-block;
        font-size: 1.4em;
        line-height: 23px;
    }

    .btn-question-button span {
        margin-top: 0px;
        display: block;
        float: left;
        text-align: left;
        font-size: 9px;
        line-height: 7px;
        padding: 3px 0px 3px 3px;
        font-weight: 300;
        max-width: 38px;
    }
    .btn-question-button:hover {
        border-radius: 10%;
        width: auto;
    }
    .btn-question-button:hover span {
        margin-top: 0px;
        display: block;
        float: left;
        text-align: left;
        font-size: 9px;
        line-height: 7px;
        padding: 3px 0px 3px 3px;
        font-weight: 300;
    }

    @media (max-width: 478px) {
        .card-header-chat > h4 {
            display: none;
        }
    }

    @media (max-width: 478px) {
        .card-header-chat {
            height: 60px;
        }
        .card-header-chat > h4 {
            font-size: 0.8rem;
            max-width: 110px;
            text-overflow: ellipsis;

            /* Required for text-overflow to do anything */
            white-space: nowrap;
            overflow: hidden;
        }
        .pinned-box {
            top: 60px;
        }
    }

    .border-new {
        border-color: var(--messages-text-color) !important;
    }
    .border-main {
        border-color: var(--background-color) !important;

    }

    .hide {
        display: none;
    }
</style>